export default __webpack_public_path__ + "images/2db94df3878fa8551348e96a4247b4fe.jpeg";